import { getCSRF } from './global'

export const initialState = {
  supportCategories: [],
  loading: false,
  error: null
}

export const POST_CONTACT_FORM = 'POST_CONTACT_FORM'
export const POST_CONTACT_FORM_SUCCESS = 'POST_CONTACT_FORM_SUCCESS'
export const POST_CONTACT_FORM_ERROR = 'POST_CONTACT_FORM_ERROR'

export const GET_SUPPORT_CATEGORIES_REQUEST = 'GET_SUPPORT_CATEGORIES_REQUEST'
export const GET_SUPPORT_CATEGORIES_SUCCESS = 'GET_SUPPORT_CATEGORIES_SUCCESS'
export const GET_SUPPORT_CATEGORIES_ERROR = 'GET_SUPPORT_CATEGORIES_ERROR'

export const postContactForm = contactForm => async (dispatch, getState, { httpRequest }) => {
  dispatch({ type: POST_CONTACT_FORM })
  try {
    const csrf = await dispatch(getCSRF())
    const res = await httpRequest.post('/contact', { ...contactForm }, {
      headers: {
        'x-csrf-token': csrf.token
      }
    })
    dispatch({ type: POST_CONTACT_FORM_SUCCESS })
    return Promise.resolve(res.data)
  } catch (err) {
    dispatch({
      type: POST_CONTACT_FORM_ERROR,
      err
    })
    return Promise.reject(err)
  }
}

export const getSupportCategories = () => (dispatch, getState, { httpRequest }) => {
  dispatch({ type: GET_SUPPORT_CATEGORIES_REQUEST })
  return httpRequest.get('/support-categories')
    .then(res => {
      dispatch({
        type: GET_SUPPORT_CATEGORIES_SUCCESS,
        categories: res.data
      })
      return Promise.resolve(res.data)
    })
    .catch(error => {
      dispatch({
        type: GET_SUPPORT_CATEGORIES_ERROR,
        error
      })
      return Promise.reject()
    })
}

const ACTION_HANDLERS = {
  [POST_CONTACT_FORM]: state => ({
    ...state,
    loading: true
  }),
  [POST_CONTACT_FORM_SUCCESS]: state => ({
    ...state,
    loading: false
  }),
  [POST_CONTACT_FORM_ERROR]: (state, { error }) => ({
    ...state,
    loading: false,
    error
  }),
  [GET_SUPPORT_CATEGORIES_REQUEST]: state => ({
    ...state,
    loading: true
  }),
  [GET_SUPPORT_CATEGORIES_SUCCESS]: (state, { categories }) => ({
    ...state,
    loading: false,
    error: null,
    supportCategories: categories
  }),
  [GET_SUPPORT_CATEGORIES_ERROR]: state => ({
    ...state,
    loading: false
  }),
}

export default function contact(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./reducers/contact.js